import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PlanCard() {
  const { user, refresh } = useAuth();
  const plus = user.plan === "plus";
  if (user.owner) return (
    <div className="card p-5 bg-[#5A3E4E] border-[#5A3E4E] text-white" data-testid="me-plan-card">
      <div className="eyebrow mb-1 !text-white/70">Your plan</div>
      <div className="font-display text-xl flex items-center gap-2" data-testid="me-owner-plan"><Crown className="h-4 w-4" />Owner access</div>
      <p className="text-xs text-white/75 mt-1">Every Plus feature, no payment needed.</p>
    </div>
  );
  const trialLeft = user.trial_ends ? Math.ceil((new Date(user.trial_ends) - Date.now()) / 864e5) : 0;
  const cancelPlan = async () => {
    await api.post("/payments/cancel");
    await refresh();
    toast.success("Your Plus plan will end at the close of this billing period.");
  };
  return (
    <div className={`card p-5 ${plus ? "bg-[#5A3E4E] border-[#5A3E4E] text-white" : ""}`} data-testid="me-plan-card">
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className={`eyebrow mb-1 ${plus ? "!text-white/70" : ""}`}>Your plan</div>
          <div className="font-display text-xl flex items-center gap-2">{plus && <Crown className="h-4 w-4" />}{plus ? "CAMRYN Plus" : "Free"}</div>
          {plus && user.plan_cancel_requested && <p className="text-xs text-white/75 mt-1">Ends at the close of this billing period</p>}
          {plus && !user.plan_cancel_requested && trialLeft > 0 && <p className="text-xs text-white/75 mt-1" data-testid="me-trial-left">Free trial: {trialLeft} day{trialLeft > 1 ? "s" : ""} left</p>}
        </div>
        {plus ? (!user.plan_cancel_requested && <button onClick={cancelPlan} data-testid="me-cancel-plan-btn" className="tap text-xs underline text-white/75 hover:text-white">{trialLeft > 0 ? "Cancel trial" : "Cancel plan"}</button>) :
          <Link to="/pricing" data-testid="me-upgrade-btn" className="btn-terra px-5 py-2.5 rounded-full text-sm font-semibold">{user.trial_eligible ? "Try Plus free" : "Upgrade"}</Link>}
      </div>
    </div>
  );
}
